import { render, staticRenderFns } from "./SocialSeriesDialog.vue?vue&type=template&id=50c58e0e&scoped=true&"
import script from "./SocialSeriesDialog.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialSeriesDialog.vue?vue&type=style&index=0&id=50c58e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c58e0e",
  null
  
)

export default component.exports